const t=(t,u)=>{const o=t.output.mul(u.input),p=u.output.mul(t.input),n=o.lt(p),l=o.gt(p),r=!n&&!l;return+(n||r&&t.output.lt(u.output))-+(l||r&&t.output.gt(u.output))},u=(u,o)=>t(o,u);export{u as sortByMaxRate,t as sortByMinRate};
